export default __webpack_public_path__ + "static/media/warningImage.191cc5aa.svg";